import Request from "./constants/Request.api"
import Api from "./Api"

const service_id = 2

class Application extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  createApplication = () => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "client/application/" + service_id,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  getAllApplications = app => {
    const request = new Request({
      data: {
        url: "clients/applications/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getProductTypes = () => {
    const request = new Request({
      data: {
        url: "disposal-types",
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getDisposalReasons = () => {
    const request = new Request({
      data: {
        url: "disposal-reasons",
      },
    })

    const response = this.getRequest(request)
    return response
  }

  saveApplication = appForm => {
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        service_id: service_id,
        is_submitted: true,
        url: "clients/applications/application-guidance-disposal",
        //token: "Bearer " + user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  getStatistics = () => {
    const request = new Request({
      data: {
        url: "client/statistics/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    return this.getRequest(request)
  }

  uploadFile = fileDetails => {
   
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", parseInt(fileDetails.application_id))
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file",
        token: "Bearer " + this.user.token,
      },
    })
     console.log("formData details", formData)
    return this.uploadRequest(request)
  }

  bulkFileUpload = files => {
    var uploadStatus = new Promise((resolve, reject) => {
      files.forEach(file => {
        this.uploadFile(file).then(response => {
          console.log("response from server upload")
          console.log(response)
        })
      })
    })

    uploadStatus.then(() => {
      return new Response({
        code: 200,
        message: "upload success",
        status: true,
      })
    })
  }

  getApplicationDetails = id => {
    console.log(this.user)
    const request = new Request({
      data: {
        url: "application/" + id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    console.log("req", request)

    return this.getRequest(request)
  }

  getServiceAttachments = () => {
    const request = new Request({
      data: {
        url: "service/attachments/" + service_id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default Application
